import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import transactionReducer from "./slices/transaction.slice"
import homeReducer from "./slices/home.slice"
import loginReducer from "./slices/login.slice"
import dialogReducer from "./slices/dialog.slice"
import loadingReducer from "./slices/loading.slice"

const persistConfig = {
  key: "root",
  storage,
}

const rootReducer = combineReducers({
  transaction: transactionReducer,
  home: homeReducer,
  login: loginReducer,
  dialog: dialogReducer,
  loading: loadingReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PURGE",
        ],
        ignoredPaths: ["register", "result", "err"],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
